<template lang="pug">
  transition(name="fade")
    #faceGeo( ref="area")
      .bg( ref="bg")
      .draw_rect( ref="rect")
      .dots( ref="dots")
      .dot_annotations( ref="dot_annotations" )
  
</template>

<script>
  import {
    MODAL_STATES,
    PATHS,
    APP_NAME,
    GETTERS,
    ACTIONS,
    MUTATIONS,
    STATES
  } from 'src/config/app'
  import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
  import { TweenLite } from 'gsap'
  import {EVENTS, default as FaceFeatureService} from "src/services/FaceFeatureService/FaceFeatureService"
  import $ from "jquery"


  export default {
    name: 'HeaderUi',
    components: {
    },
    data() {
      return {
        face_info:null,
      }
    },
    props: {},
    computed: {},
    
    mounted() {
      FaceFeatureService.on(EVENTS.faceInfo, this.onFaceInfo)
    },
    
    beforeDestroy() {},
    
    methods: {
      ...mapMutations(APP_NAME, [
        MUTATIONS.setAppState,
        MUTATIONS.setModalState
      ]),

      onFaceInfo(info){
        this.img = FaceFeatureService.faceImage
        this.face_info = info
      },

      drawGeo(){
        
        let drawRect = this.$refs.rect
        let drawArea = this.$refs.area
        let dots = this.$refs.dots
        let annotations = this.$refs.dot_annotations
        
        let $dots= $(dots)

        //clear dots
        dots.innerHTML = ""
        annotations.innerHTML = ""
        
        if (!this.face_info){
          drawArea.style.opacity=0;
          return
        }

        let o = this.face_info.faceBounds;
        let a = o.angle
        let h= o.height
        let w = o.width
        let x = o.x
        let y = o.y
    
        drawArea.style.opacity=1;
    
        //getImageBounds from model
        let hd = drawArea.getBoundingClientRect().height;
        let hi = this.img.height;
        let s = 1/(hi/hd)
    
        //draw rect
        TweenLite.set(drawRect,{
          x:(x-(w*0.5))*s,
          y:(y-(h*0.5))*s,
          width:w*s,
          height:h*s,
          rotation:-a
        });
        
        //draw dots
        o = this.face_info.geo;
        for(let k in o){
          let v = o[k];
          let message= k
          let x = v.x*s
          let y = v.y*s
          let $dot = $('<div />')
          $dot.addClass('draw_dot')
          $dots.append($dot)
          TweenLite.set($dot,{x:x, y:y})
        }
        
        //draw basic dots
        o = this.face_info.geoBasic;
        for(let k in o){
          let v = o[k];
          let message= k
          let x = v.x*s
          let y = v.y*s
          let $dot = $('<div />')
          $dot.addClass('draw_dot basic')
          $dots.append($dot)
          $dot.on('mouseenter', ()=>{console.log('geo:',message)})
          TweenLite.set($dot,{x:x, y:y})
        }
      }
    
  },
    
    watch: {
      face_info(){
        this.drawGeo()
      }
    },
  }
</script>

<style lang="sass">
  @import "src/styles/common.sass"

  #faceGeo
    z-index: 1
    +full()
    overflow: hidden
    opacity: 0
      
    .bg
      +full()
      background-color:  rgba(0,0,0,0.5)

    .draw_area
      +full()
      display: block

    .draw_rect
      +ab()
      border:  1px solid #00d700
      width: 30px
      height: 30px
    
  
    .dots
      +full()
      display: block

    .dot_annotations
      +full()
      display: block
      
      
    .dot_annotate
      +ab()
      background-color:  rgba(0,0,0,0.6)
      color:  white
      height:  3px
      line-height:  3px
      font-size:  2px
    
  
    .draw_dot
      +ab()
      background-color: #00ffff
      width: 1px
      height: 1px
      border-radius:  0.5px
      margin-left:  -0.5px
      margin-right:  -0.5px
      
      &.basic
        background-color: white
        width: 2px
        height: 2px
        border-radius:  1px
        margin-left:  -1px
        margin-right:  -1px
  


</style>
